import AICatalystMessage from './AICatalystMessage'

export default AICatalystMessage
